import React, { useState, useEffect } from 'react';
import './DuelPage.css';
import { loadDeckFromStorage } from '../logic/DuelLogic';
import { handleDeckAction } from '../logic/DuelLogic';
import ZoneSlot from '../components/ZoneSlot';
import HandCard from '../components/HandCard';
import DeckModal from '../components/DeckModal';
import ZoneViewerModal from '../components/ZoneViewerModal';
import HandMenuModal from '../components/HandMenuModal';
import DeckMenuModal from '../components/DeckMenuModal';
import CardRevealModal from '../components/CardRevealModal';
import ExtraMenuModal from '../components/ExtraMenuModal';
import ExtraCardModal from '../components/ExtraCardModal';
import FieldCardModal from '../components/FieldCardModal';
import ZoneCardModal from '../components/ZoneCardModal';
import { playSound } from '../utils/soundPlayer';
import { useParams } from 'react-router-dom';
import { db, doc, getDoc, updateDoc, onSnapshot, serverTimestamp } from '../firebase';
import { getAuth } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import actSound from '../assets/sounds/act.wav';
import { toast } from 'react-toastify';






const DuelPage = () => {
  const navigate = useNavigate();
  const actAudio = new Audio(actSound);
  const { t } = useTranslation();
  const [mainDeck, setMainDeck] = useState([]);
  const [extraDeck, setExtraDeck] = useState([]);
  const [sideDeck, setSideDeck] = useState([]);
  const [hand, setHand] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [fieldMap, setFieldMap] = useState({});
  const [showDeckMenu, setShowDeckMenu] = useState(false);
  const [deckMenuPosition, setDeckMenuPosition] = useState({ top: 0, left: 0 });
  const [showDeckModal, setShowDeckModal] = useState(false);
  const [myGYZ, setMyGYZ] = useState([]);  // instead of null
  const [myBZ, setMyBZ] = useState([]);
  const [viewZoneCards, setViewZoneCards] = useState([]);
  const [zoneViewerTitle, setZoneViewerTitle] = useState('');
  const [handMenuCard, setHandMenuCard] = useState(null);
  const [pendingSummon, setPendingSummon] = useState(null);
  const [pendingNormalSummon, setPendingNormalSummon] = useState(null);
  const [summonPosition, setSummonPosition] = useState('ATK');
  const [revealCard, setRevealCard] = useState(null);
  const [revealTitle, setRevealTitle] = useState('');
  const [pendingSTPlacement, setPendingSTPlacement] = useState(null);
  const [showExtraMenu, setShowExtraMenu] = useState(false);
  const [extraCardModalCard, setExtraCardModalCard] = useState(null);
  const [pendingExtraSummon, setPendingExtraSummon] = useState(null);
  const [extraSummonPosition, setExtraSummonPosition] = useState('ATK');
  const [pendingFieldMove, setPendingFieldMove] = useState(null);
  const [pendingFieldPlacement, setPendingFieldPlacement] = useState(null);
  const [zoneCardModal, setZoneCardModal] = useState(null);
  const [pendingOverlay, setPendingOverlay] = useState(null);
  const [pendingSSATKHand, setPendingSSATKHand] = useState(null);
  const [pendingSSDEFHand, setPendingSSDEFHand] = useState(null);
  const [pendingSetMonsterHand, setPendingSetMonsterHand] = useState(null);
  const [pendingToken, setPendingToken] = useState(false);
  const { roomId } = useParams();
  const [pendingPendulum, setPendingPendulum] = useState(null);
  const [highlightedCard, setHighlightedCard] = useState(null);
  const [highlightedHandCard, setHighlightedHandCard] = useState(null);
  const [submitting, setSubmitting] = useState(false);


  const syncGameState = async (updatedPartialState) => {
    if (!roomId || !playerRole) return;

    const roomRef = doc(db, 'duelRooms', roomId);

    await updateDoc(roomRef, {
      [`gameState.${playerRole}`]: {
        ...(await getDoc(roomRef)).data()?.gameState?.[playerRole],
        ...updatedPartialState,
      },
      updatedAt: serverTimestamp()
    });
  };


  const user = getAuth().currentUser;
  const [playerRole, setPlayerRole] = useState(null); // 'host' or 'guest'
  const [opponentFieldMap, setOpponentFieldMap] = useState({});
  const [opponentGY, setOpponentGY] = useState([]);
  const [opponentBZ, setOpponentBZ] = useState([]);
  const [opponentActionMessage, setOpponentActionMessage] = useState('');




  const resetAllPendingStates = () => {
    setPendingSummon(null);
    setPendingNormalSummon(null);
    setPendingSTPlacement(null);
    setPendingFieldPlacement(null);
    setPendingExtraSummon(null);
    setPendingFieldMove(null);
    setPendingOverlay(null);
    setPendingSSATKHand(null);
    setPendingSSDEFHand(null);

  };
  const handleDetachXyzMaterial = (index) => {
    const detachedCard = viewZoneCards[index];
    const updatedList = [...viewZoneCards];
    updatedList.splice(index, 1);

    const xyzZone = Object.keys(fieldMap).find(zone =>
      fieldMap[zone]?.overlays?.some(c => c.id === detachedCard.id)
    );

    if (!xyzZone) return;

    const updatedFieldMap = { ...fieldMap };
    updatedFieldMap[xyzZone].overlays = updatedFieldMap[xyzZone].overlays.filter(c => c.id !== detachedCard.id);

    setFieldMap(updatedFieldMap);
    setMyGYZ(prev => [...prev, detachedCard]);
    setViewZoneCards(updatedList);

    syncGameState({
      fieldMap: updatedFieldMap,
      hand,
      mainDeck,
      extraDeck,
      gy: [...myGYZ, detachedCard],
      bz: myBZ,
      roomId,
      playerRole
    });
  };



  useEffect(() => {
    const auth = getAuth();
    let unsubscribe;

    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      if (!user || !roomId) return;

      const roomRef = doc(db, 'duelRooms', roomId);
      const snapshot = await getDoc(roomRef);
      const roomData = snapshot.data();

      if (!roomData) return;

      const isHost = roomData.hostUid === user.uid;
      const myRole = isHost ? 'host' : 'guest';
      const opponentRole = isHost ? 'guest' : 'host';

      setPlayerRole(myRole);

      // ✅ Initialize gameState if host and not set
      if (isHost && !roomData.gameState) {
        const gameState = {
          host: {
            mainDeck,
            extraDeck,
            hand,
            fieldMap,
            gy: myGYZ,
            bz: myBZ
          },
          guest: {
            mainDeck: [],
            extraDeck: [],
            hand: [],
            fieldMap: {},
            gy: [],
            bz: []
          },
          turn: 'host',
          updatedAt: serverTimestamp()
        };

        await updateDoc(roomRef, { gameState });
      }


      unsubscribe = onSnapshot(roomRef, (snap) => {
        const data = snap.data();
        if (!data?.gameState) return;

        const state = data.gameState[myRole];
        const opponentState = data.gameState[opponentRole];


        // ✅ Only update if values exist to avoid wiping good data
        if (state.mainDeck?.length > 0) setMainDeck(state.mainDeck);
        if (state.extraDeck?.length > 0) setExtraDeck(state.extraDeck);
        if (state.hand?.length > 0) setHand(state.hand);

        setFieldMap(state.fieldMap || {});
        setMyGYZ(state.gy || []);
        setMyBZ(state.bz || []);

        if (opponentState) {
          // ✅ Detect visible summon BEFORE masking
          const summon = Object.entries(opponentState.fieldMap || {}).find(
            ([zoneLabel, zoneData]) =>
              zoneLabel.includes('MZ') &&
              zoneData?.from === 'hand' &&
              !zoneData.card?.isFaceDown
          );
          if (summon) {
            setOpponentActionMessage('Opponent summoned a monster from hand!');
            setTimeout(() => setOpponentActionMessage(''), 3000);
          }

          // ✅ Mask opponent face-down cards
          const filteredFieldMap = {};
          for (const zone in opponentState.fieldMap) {
            const slot = opponentState.fieldMap[zone];
            filteredFieldMap[zone] = {
              ...slot,
              card: slot.card?.isFaceDown
                ? { name: 'Face-down', isFaceDown: true }
                : slot.card
            };
          }

          setOpponentFieldMap(filteredFieldMap);
          setOpponentGY(opponentState.gy?.map(card =>
            card.isFaceDown ? { name: 'Face-down', isFaceDown: true } : card
          ) || []);
          setOpponentBZ(opponentState.bz?.map(card =>
            card.isFaceDown ? { name: 'Face-down', isFaceDown: true } : card
          ) || []);
        }
      });
    });


    return () => {
      unsubscribeAuth();
      if (unsubscribe) unsubscribe();
    };
  }, []);


  useEffect(() => {
    const fetchDeck = async () => {
      const handTestData = JSON.parse(localStorage.getItem('handTestDeck') || 'null');
      if (handTestData) {
        setMainDeck(handTestData.main);
        setExtraDeck(handTestData.extra.map(card => ({ ...card, isFaceDown: true })));
        setSideDeck(handTestData.side);
        setHand(handTestData.hand || []);

        localStorage.removeItem('handTestDeck');

        return;
      }

      const localData = await loadDeckFromStorage();


      if (localData?.source === 'online') {
        try {
          const auth = getAuth();
          const user = auth.currentUser;
          if (!user) return;

          const deckRef = doc(db, 'users', user.uid, 'decks', localData.id);
          const snapshot = await getDoc(deckRef);
          const data = snapshot.data();

          const res = await fetch('https://db.ygoprodeck.com/api/v7/cardinfo.php');
          let cardDB = (await res.json()).data;
          cardDB = Array.from(new Map(cardDB.map(c => [String(c.id), c])).values());

          const resolve = (ids = []) =>
            ids.map(id =>
              cardDB.find(c => String(c.id) === String(id)) ||
              cardDB.find(c => c.misc_info?.alias?.includes(Number(id))) ||
              cardDB.find(c => c.card_images?.some(img => String(img.id) === String(id))) ||
              { id, name: `Unknown (${id})`, card_images: [{ image_url: 'https://via.placeholder.com/80x115?text=Unknown' }] }
            );

          setMainDeck(resolve(data.main));
          setExtraDeck(resolve(data.extra).map(card => ({ ...card, isFaceDown: true })));
          setSideDeck(resolve(data.side));
          setHand([]); // You can implement a shuffle if needed

        } catch (err) {
        }
      } else if (localData) {
        setMainDeck(localData.main);
        setExtraDeck(localData.extra.map(card => ({ ...card, isFaceDown: true })));
        setSideDeck(localData.side);
        setHand(localData.hand || []);
      }
    };

    fetchDeck();
  }, []);



  const gridLayout = [
    ['Opp Deck', 'Opp GYZ', 'Opp BZ', 'My FZ', 'My Extra'],
    ['My STZ10', 'My MZ10', '', 'My MZ1', 'My STZ1'],
    ['My STZ9', 'My MZ9', 'EXMZ1', 'My MZ2', 'My STZ2'],
    ['My STZ8', 'My MZ8', 'TOKEN_BUTTON', 'My MZ3', 'My STZ3'],
    ['My STZ7', 'My MZ7', 'EXMZ2', 'My MZ4', 'My STZ4'],
    ['My STZ6', 'My MZ6', '', 'My MZ5', 'My STZ5'],
    ['Opp Extra', 'Opp FZ', 'My BZ', 'My GYZ', 'My Deck']
  ];

  const handleFieldCardAction = (action, card) => {
    resetAllPendingStates(); // 🧹 prevent leftover actions
    const sendOverlaysToGY = (zone) => {
      const overlays = fieldMap[zone]?.overlays || [];
      if (overlays.length > 0) {
        setMyGYZ(prev => [...prev, ...overlays]);
      }
    };

    const zone = card.zone;
    const isExtra = card.type?.match(/Fusion|Synchro|XYZ|Link/);
    const cardCopy = { ...card };
    // ✅ Always reset face-down state if relevant action
    const resetFaceDownActions = [
      'Move',
      'To Bottom Deck',
      'To Top Deck',
      'Banish',
      'Banish FD',
      'To hand',
      'To Extra',
      'Activate ST',
      'To GY',
      'Flip',
      'Flip Summon'
    ];
    if (cardCopy.isFaceDown && resetFaceDownActions.includes(action)) {
      cardCopy.isFaceDown = false;
    }

    const removeCardFromField = () => {
      setFieldMap(prev => {
        const updated = { ...prev };
        delete updated[zone];
        syncGameState({ fieldMap: updated }); // ✅
        return updated;
      });
    };

    const moveToDeck = (position = 'top') => {
      removeCardFromField();
      if (isExtra) {
        setExtraDeck(prev => position === 'top' ? [cardCopy, ...prev] : [...prev, cardCopy]);
      } else {
        setMainDeck(prev => position === 'top' ? [cardCopy, ...prev] : [...prev, cardCopy]);
      }
    };

    switch (action) {
      case 'To GY':
        playSound('gy');
        sendOverlaysToGY(zone);
        removeCardFromField();
        setMyGYZ(prev => [...prev, cardCopy]);
        break;
      case 'Remove':
        removeCardFromField(); // ✅ instantly deletes the token
        break;

      case 'Banish':
        playSound('gy');
        sendOverlaysToGY(zone);
        removeCardFromField();
        setMyBZ(prev => [...prev, cardCopy]);
        break;

      case 'Banish FD':
        playSound('gy');
        sendOverlaysToGY(zone);
        removeCardFromField();
        cardCopy.isFaceDown = true;
        setMyBZ(prev => [...prev, cardCopy]);
        break;

      case 'To Top Deck':
      case 'To Top Extra':
        sendOverlaysToGY(zone);
        moveToDeck('top');
        break;

      case 'To Bottom Deck':
      case 'To Bottom Extra':
        sendOverlaysToGY(zone);
        moveToDeck('bottom');
        break;

      case 'To hand':
      case 'To Extra':
        sendOverlaysToGY(zone);
        removeCardFromField();

        if (!isExtra) {
          setHand(prev => [...prev, cardCopy]);
        } else {
          cardCopy.isFaceDown = true; // ✅ Mark face-down before sending to Extra
          setExtraDeck(prev => [cardCopy, ...prev]);
        }

        break;


      case 'Set':
        playSound('set');
        setFieldMap(prev => {
          const updated = {
            ...prev,
            [zone]: {
              card: { ...cardCopy, isFaceDown: true },
              position: 'DEF',
              overlays: prev[zone]?.overlays || [],
              from: 'hand'
            }
          };
          syncGameState({ fieldMap: updated }); // ✅
          return updated;
        });
        break;

      case 'To DEF':
        playSound('gy');
        setFieldMap(prev => ({
          ...prev,
          [zone]: {
            ...prev[zone],
            position: 'DEF',
            overlays: prev[zone]?.overlays || []
          }
        }));
        break;
      case 'To ATK':
        playSound('gy');
        setFieldMap(prev => ({
          ...prev,
          [zone]: {
            ...prev[zone],
            position: 'ATK',
            overlays: prev[zone]?.overlays || []
          }
        }));
        break;


      case 'Flip':
        playSound('gy');
        setFieldMap(prev => ({
          ...prev,
          [zone]: {
            ...prev[zone],
            card: { ...cardCopy, isFaceDown: false },
            position: 'DEF',
            overlays: prev[zone]?.overlays || []
          }
        }));
        break;

      case 'Flip Summon':
        playSound('ns');
        setFieldMap(prev => ({
          ...prev,
          [zone]: {
            ...prev[zone],
            card: { ...cardCopy, isFaceDown: false },
            position: 'ATK',
            overlays: prev[zone]?.overlays || []
          }
        }));
        break;

      case 'Declare':
        actAudio.play(); // 🔊 Play sound

        // 🟡 Temporarily flag the card for visual highlight
        setHighlightedCard(card); // card should be the selected field card

        setTimeout(() => {
          setHighlightedCard(null); // remove highlight after 1 sec
        }, 1000);

        break;


      case 'Target':
        setRevealCard(cardCopy);
        setRevealTitle('Target Selected');
        break;

      case 'Activate ST':
        playSound('act');
        setFieldMap(prev => ({
          ...prev,
          [zone]: {
            ...prev[zone],
            card: { ...cardCopy, isFaceDown: false }
          }
        }));
        break;

      case 'Xyz Material':

        setPendingOverlay({ ...card, zone }); // Save the overlay material
        break;

      case 'Show Material':
        setViewZoneCards(fieldMap[card.zone]?.overlays || []);
        setZoneViewerTitle('XYZ Materials');
        break;
      case 'To Extra FaceUp':
        playSound('bz'); // optional
        sendOverlaysToGY(zone); // detach anything
        removeCardFromField();
        cardCopy.isFaceDown = false; // ensure it's face-up
        setExtraDeck(prev => [cardCopy, ...prev]); // ✅ top of Extra Deck
        break;



      case 'Move':
        setPendingFieldMove({ ...cardCopy, zone });
        //removeCardFromField();
        break;

      default:
        break;
    }

    setSelectedCard(null); // Close modal
    if (action !== 'Xyz Material') {
      setPendingOverlay(null); // Cancel overlay mode unless it's 'Overlay'
    }


  };

  const handleZoneCardAction = (action, card, origin) => {
    resetAllPendingStates();
    const cardCopy = { ...card };
    const isExtra = card.type?.match(/Fusion|Synchro|XYZ|Link/);
    const isMonster = card.type?.includes('Monster');

    // Always reset face-down for reuse
    cardCopy.isFaceDown = false;

    const removeFromZone = () => {
      if (origin === 'GY') {
        setMyGYZ(prev => prev.filter(c => c !== card));
      } else if (origin === 'BZ') {
        setMyBZ(prev => prev.filter(c => c !== card));
      } else if (origin === 'Deck') {
        setMainDeck(prev => prev.filter(c => c !== card.original));
      }
    };
    if (action === 'To Extra') {
      if (zoneCardModal.origin === 'GY') {
        const newGY = [...myGYZ];
        const index = newGY.findIndex(c => c === zoneCardModal.card || c === zoneCardModal.card.original);
        if (index !== -1) {
          newGY.splice(index, 1);
          setMyGYZ(newGY);
          setExtraDeck(prev => [...prev, zoneCardModal.card]);
        }
      } else if (zoneCardModal.origin === 'BZ') {
        const newBZ = [...myBZ];
        const index = newBZ.findIndex(c => c === zoneCardModal.card || c === zoneCardModal.card.original);
        if (index !== -1) {
          newBZ.splice(index, 1);
          setMyBZ(newBZ);
          setExtraDeck(prev => [...prev, zoneCardModal.card]);
        }
      }
      setZoneCardModal(null);
    }

    switch (action) {
      case 'To GY':
        playSound('gy');
        removeFromZone();
        setMyGYZ(prev => [...prev, cardCopy]);
        break;

      case 'To Bottom Deck':
        playSound('gy');
        removeFromZone();
        setMainDeck(prev => [...prev, cardCopy]);
        break;

      case 'To Top Deck':
        playSound('gy');
        removeFromZone();
        setMainDeck(prev => [cardCopy, ...prev]);
        break;

      case 'Banish':
        playSound('gy');
        removeFromZone();
        setMyBZ(prev => [...prev, cardCopy]);
        break;

      case 'Banish FD':
        playSound('gy');
        removeFromZone();
        setMyBZ(prev => [...prev, { ...cardCopy, isFaceDown: true }]);
        break;

      case 'To Hand':
        playSound('gy');
        removeFromZone();
        setHand(prev => [...prev, { ...cardCopy, origin: 'hand' }]);
        break;

      case 'To S/T':

        removeFromZone(); // ✅ Add this line
        cardCopy.origin = origin;
        cardCopy.original = card; // ✅ Track the original clicked card
        cardCopy.isFaceDown = true;
        setPendingSTPlacement(cardCopy);
        break;

      case 'SS ATK':

        cardCopy.origin = origin; // 🔁 Used later for removal
        cardCopy.original = card; // ✅ track exact card clicked
        setPendingSummon(cardCopy);
        setSummonPosition('ATK');
        break;

      case 'SS DEF':

        cardCopy.origin = origin; // 🔁 Used later for removal
        cardCopy.original = card; // ✅ track exact card clicked
        setPendingSummon(cardCopy);
        setSummonPosition('DEF');
        break;

      case 'SS ATK GY':
        cardCopy.origin = origin;
        cardCopy.original = card;
        setPendingSummon(cardCopy);
        setSummonPosition('ATK');
        break;

      case 'SS DEF GY':
        cardCopy.origin = origin;
        cardCopy.original = card;
        setPendingSummon(cardCopy);
        setSummonPosition('DEF');
        break;


      case 'Declare':
        setRevealCard(cardCopy);
        setRevealTitle('Effect Declaration');
        break;

      case 'Target':
        setRevealCard(cardCopy);
        setRevealTitle('Target Selected');
        break;

      default:
        break;
    }

    setZoneCardModal(null); // ✅ Close the modal
    setViewZoneCards([]);
  };




  const onDeckAction = (action) => {
    if (action === 'View') {
      setViewZoneCards(mainDeck);
      setZoneViewerTitle('Deck');
      return;
    }

    if (action === 'Banish FD') {
      if (mainDeck.length === 0) return;
      const topCard = mainDeck[mainDeck.length - 1];
      setMainDeck(prev => prev.slice(0, -1)); // remove last
      setMyBZ(prev => [...prev, { ...topCard, isFaceDown: true }]); // ✅ add to BZ
      return;
    }

    // 👇 Other actions like Mill, Shuffle, Draw
    handleDeckAction({
      action,
      mainDeck,
      setMainDeck,
      setHand,
      setMyBZ,
      setMyGYZ,
      hand,             // ✅ ADD THIS
      extraDeck,
      myGYZ,
      myBZ,
      roomId,
      playerRole,
      fieldMap          // ✅ optional, good for syncing
    });
  };

  const handleExtraDeckAction = (action) => {
    if (action === 'View') {
      setViewZoneCards(extraDeck);
      setZoneViewerTitle('Extra Deck');
    } else if (action === 'Shuffle') {
      playSound('shuffle');
      const shuffled = [...extraDeck].sort(() => Math.random() - 0.5);
      setExtraDeck(shuffled);
    } else if (action === 'Banish FD') {
      playSound('bz');
      if (extraDeck.length === 0) return;
      const topCard = extraDeck[extraDeck.length - 1];
      setExtraDeck(prev => prev.slice(0, -1));
      setMyBZ(prev => [...prev, { ...topCard, isFaceDown: true }]);
    }
  };
  const handleExtraCardAction = (action) => {
    resetAllPendingStates(); // 🧹 clear old pending extra summons

    if (!extraCardModalCard) return;

    if (action === 'Reveal') {
      setRevealCard(extraCardModalCard);
      setRevealTitle('Reveal');
      setExtraCardModalCard(null);
    } else if (action === 'Banish FD') {
      playSound('bz');
      setExtraDeck(prev => prev.filter(c => c !== extraCardModalCard));
      setMyBZ(prev => [...prev, { ...extraCardModalCard, isFaceDown: true }]);
      setExtraCardModalCard(null);
    } else if (action === 'Banish') {
      playSound('bz');
      setExtraDeck(prev => prev.filter(c => c !== extraCardModalCard));
      setMyBZ(prev => [...prev, extraCardModalCard]);
      setExtraCardModalCard(null);
    } else if (action === 'To GY') {
      playSound('bz');
      setExtraDeck(prev => prev.filter(c => c !== extraCardModalCard));
      setMyGYZ(prev => [...prev, extraCardModalCard]);
      setExtraCardModalCard(null);
    } else if (action === 'SS ATK') {
      setPendingExtraSummon(extraCardModalCard);
      setExtraSummonPosition('ATK');
      setExtraCardModalCard(null);
    } else if (action === 'SS DEF') {
      setPendingExtraSummon(extraCardModalCard);
      setExtraSummonPosition('DEF');
      setExtraCardModalCard(null);
    } else if (action === 'XYZ Summon') {
      setPendingExtraSummon({ ...extraCardModalCard, xyzMode: true });
      setExtraSummonPosition('ATK'); // or let user pick

      setExtraCardModalCard(null);
    }
    // ✅ Always close both modals after an action
    setExtraCardModalCard(null);
    setViewZoneCards([]); // Closes the Extra Deck viewer
  };


  const handleHandAction = (action) => {
    if (!handMenuCard) return;
    resetAllPendingStates(); // 🧹 clear old pending actions


    if (action === 'To GY') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMyGYZ(prev => [...prev, handMenuCard]);
      setHandMenuCard(null);
    } else if (action === 'Banish') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMyBZ(prev => [...prev, handMenuCard]);
      setHandMenuCard(null);
    } else if (action === 'SS ATK') {
      setPendingSSATKHand(handMenuCard); // new summon state
      setSummonPosition('ATK');
      setHandMenuCard(null);          // ✅ close overlay
    } else if (action === 'N.Summon') {
      setPendingNormalSummon(handMenuCard); // 🔥 activate N.Summon mode
      setHandMenuCard(null);
    } else if (action === 'SS DEF') {
      setPendingSSDEFHand(handMenuCard); // new summon state
      setSummonPosition('DEF');
      setHandMenuCard(null);
    } else if (action === 'Banish FD') {
      playSound('bz');
      setHand(prev => prev.filter(c => c !== handMenuCard));
      // Add a flag to indicate face-down
      setMyBZ(prev => [
        ...prev,
        {
          ...handMenuCard,
          isFaceDown: true
        }
      ]);
      setHandMenuCard(null);
    } else if (action === 'Declare') {
      // 🔊 Play act.wav
      const audio = new Audio(require('../assets/sounds/act.wav'));
      audio.play();

      // ✅ Highlight the card in hand
      setHighlightedHandCard(handMenuCard);

      setTimeout(() => {
        setHighlightedHandCard(null);
      }, 1000);

      setHandMenuCard(null);
    }
    else if (action === 'Reveal') {
      setRevealCard(handMenuCard);
      setRevealTitle('Reveal');
      setHandMenuCard(null);
    }
    else if (action === 'To S/T' || action === 'Activate') {
      const cardCopy = {
        ...handMenuCard,
        isFaceDown: action === 'To S/T',
        original: handMenuCard, // ✅ store reference so we can remove it later
        isPendulum: action === 'Activate' && handMenuCard.type.includes('Pendulum') // ✅ new flag

      };

      setPendingSTPlacement(cardCopy); // 🕐 card will be placed when clicking on STZ
      setHandMenuCard(null);
    }

    else if (action === 'To Top Deck') {
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMainDeck(prev => [handMenuCard, ...prev]); // ⬆️ Top means unshift
      setHandMenuCard(null);
    }
    else if (action === 'To Bottom deck') {
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setMainDeck(prev => [...prev, handMenuCard]); // ⬇️ Bottom means push
      setHandMenuCard(null);
    } else if (action === 'Set S/T') {

      const cardCopy = { ...handMenuCard, isFaceDown: true };
      cardCopy.original = handMenuCard; // ✅ Keep reference to original object
      setPendingSTPlacement(cardCopy);
      setHandMenuCard(null);
    } else if (action === 'Set Monster Zone') {

      const cardCopy = { ...handMenuCard, isFaceDown: true };
      cardCopy.original = handMenuCard;
      setPendingSetMonsterHand(cardCopy); // 🆕 New state
      setSummonPosition('DEF'); // ensure defense
      setHandMenuCard(null);
    } else if (action === 'Set Field' || action === 'Activate Field') {
      const newCard = {
        ...handMenuCard,
        isFaceDown: action === 'Set Field'
      };

      // ✅ Get the old FZ card BEFORE changing anything
      const oldCardToGY = fieldMap['My FZ']?.card || null;

      // ✅ Replace field spell
      setFieldMap(prev => ({
        ...prev,
        'My FZ': {
          card: newCard,
          position: 'FACEUP',
          from: 'hand',
          type: 'Field'
        }
      }));

      // ✅ Safely send the old one to GY
      if (oldCardToGY) {
        setMyGYZ(prev => [...prev, oldCardToGY]);
      }

      // ✅ Remove from hand
      setHand(prev => prev.filter(c => c !== handMenuCard));
      setHandMenuCard(null);
    }


    else {
      setHandMenuCard(null); // just close overlay for others
    }
  };
  const handleCardClickFromZone = (card) => {
    switch (zoneViewerTitle) {
      case 'Extra Deck':
        setExtraCardModalCard(card);
        break;
      case 'Graveyard':
        setZoneCardModal({ card, origin: 'GY' });
        break;
      case 'Banished':
        setZoneCardModal({ card, origin: 'BZ' });
        break;
      case 'Deck':
        setZoneCardModal({ card: { ...card, original: card }, origin: 'Deck' });
        break;
      default:
        break;
    }
  };

  return (


    <div className="duel-container" style={{ backgroundImage: "url('/background.png')" }}>
      <div className="role-banner">

      </div>
      <div className="duel-inner">
        <div className="duel-field-grid">
          {gridLayout.map((column, colIdx) => (
            <div key={colIdx} className="duel-column">
              {column.map((label, rowIdx) => {
                const isOpponentZone = label.startsWith('Opp');
                const activeFieldMap = isOpponentZone ? opponentFieldMap : fieldMap;

                if (label === 'TOKEN_BUTTON') {
                  return (
                    <div
                      key={rowIdx}
                      className="zone"
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'flex',
                        backgroundColor: '#2c2c2c',
                        color: 'white'
                      }}
                      onClick={() => setPendingToken(true)}
                    >
                      Token
                    </div>
                  );
                }

                return (
                  <ZoneSlot
                    key={rowIdx}
                    label={label}
                    fieldMap={label.startsWith('Opp') ? opponentFieldMap : fieldMap}
                    highlightedCard={highlightedCard}
                    setFieldMap={setFieldMap}
                    pendingSummon={pendingSummon}
                    setPendingSummon={setPendingSummon}
                    pendingNormalSummon={pendingNormalSummon}
                    setPendingNormalSummon={setPendingNormalSummon}
                    setHand={setHand}
                    myGYZ={myGYZ}
                    myBZ={myBZ}
                    setViewZoneCards={setViewZoneCards}
                    setZoneViewerTitle={setZoneViewerTitle}
                    showDeckMenu={showDeckMenu}
                    setShowDeckMenu={setShowDeckMenu}
                    mainDeck={mainDeck}
                    onDeckAction={onDeckAction}
                    summonPosition={summonPosition}
                    pendingSTPlacement={pendingSTPlacement}
                    setPendingSTPlacement={setPendingSTPlacement}
                    setMyGYZ={setMyGYZ}
                    extraDeck={extraDeck}
                    setShowExtraMenu={setShowExtraMenu}
                    pendingExtraSummon={pendingExtraSummon}
                    setPendingExtraSummon={setPendingExtraSummon}
                    extraSummonPosition={extraSummonPosition}
                    setSelectedCard={setSelectedCard}
                    pendingFieldMove={pendingFieldMove}
                    setPendingFieldMove={setPendingFieldMove}
                    pendingFieldPlacement={pendingFieldPlacement}
                    setPendingFieldPlacement={setPendingFieldPlacement}
                    setExtraDeck={setExtraDeck}
                    setMyBZ={setMyBZ}
                    setMainDeck={setMainDeck}
                    pendingOverlay={pendingOverlay}
                    setPendingOverlay={setPendingOverlay}
                    pendingSSATKHand={pendingSSATKHand}
                    setPendingSSATKHand={setPendingSSATKHand}
                    pendingSSDEFHand={pendingSSDEFHand}
                    setPendingSSDEFHand={setPendingSSDEFHand}
                    pendingSetMonsterHand={pendingSetMonsterHand}
                    setPendingSetMonsterHand={setPendingSetMonsterHand}
                    pendingToken={pendingToken}
                    setPendingToken={setPendingToken}
                    roomId={roomId}
                    playerRole={playerRole}
                    db={db}
                    hand={hand}
                    onDetach={handleDetachXyzMaterial} // ✅ add this
                    setPendingPendulum={setPendingPendulum}
                  />
                );
              })}
            </div>

          ))}
        </div>
        {showDeckModal && (
          <DeckModal
            mainDeck={mainDeck}
            onClose={() => setShowDeckModal(false)}
          />
        )}

        <div className="hand-bar">
          <div className="hand-inner">
            {hand.map((card, index) => (
              <HandCard
                key={card.id + '-' + index}
                card={card}
                onClick={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  setHandMenuCard(card);
                }
                }
                isHighlighted={highlightedHandCard === card} // ✅ pass this prop
              />
            ))}
          </div>
        </div>
      </div>
      {viewZoneCards.length > 0 && (
        <ZoneViewerModal
          cards={viewZoneCards}
          title={zoneViewerTitle}
          onClose={() => setViewZoneCards([])}
          onCardClick={handleCardClickFromZone}
          onDetach={handleDetachXyzMaterial} // ✅ Add this line

        />

      )}
      {extraCardModalCard && (
        <ExtraCardModal
          card={extraCardModalCard}
          onAction={handleExtraCardAction}
          onClose={() => setExtraCardModalCard(null)}
        />
      )}

      {zoneCardModal && (
        <ZoneCardModal
          card={zoneCardModal.card}
          origin={zoneCardModal.origin}
          onClose={() => setZoneCardModal(null)}
          onAction={(action) =>
            handleZoneCardAction(action, zoneCardModal.card, zoneCardModal.origin)
          }
        />
      )}

      <HandMenuModal
        card={handMenuCard}
        onAction={handleHandAction}
        onClose={() => setHandMenuCard(null)}
      />

      <DeckMenuModal
        visible={showDeckMenu}
        onAction={(action) => {
          onDeckAction(action);
          setShowDeckMenu(false);
        }}
        onClose={() => setShowDeckMenu(false)}
      />
      <ExtraMenuModal
        visible={showExtraMenu}
        onAction={(action) => {
          handleExtraDeckAction(action);
          setShowExtraMenu(false);
        }}
        onClose={() => setShowExtraMenu(false)}
      />

      <CardRevealModal
        card={revealCard}
        title={revealTitle}
        onClose={() => setRevealCard(null)}
      />
      {selectedCard && (
        <FieldCardModal
          card={selectedCard}
          onClose={() => setSelectedCard(null)}
          onAction={(action) => handleFieldCardAction(action, selectedCard)}
        />
      )}
      <button className="back-button-duel" onClick={() => {
        playSound('return');
        navigate('/deckbuilder');
      }}>
        {t('cardSearch.back')}
      </button>




    </div>
  );
};

export default DuelPage;
